// biome-ignore lint/style/noRestrictedImports: component usage
import { Item } from "@radix-ui/react-toggle-group";
import { type VariantProp, cv } from "@suse-o11y/class-variance";
import React from "react";

import { useFormContext } from "~/components/form/use-form-context";

/**
 * Check out Figma for the design of the radio button group token:
 *
 * @link
https://www.figma.com/design/YIkZms7ygvgqXYnbzDFr8Y/--StackState-DS?node-id=4369-1364&m=dev
 */

const variants = cv("radio-button aria-checked:radio-button-selected disabled:radio-button-disabled", {
	variants: {
		size: {
			sm: "radio-button-sm",
			md: "radio-button-md",
			lg: "radio-button-lg",
		},
	},
	defaultVariants: {
		size: "md",
	},
});

interface RadioButtonGroupItemProps extends React.ComponentPropsWithoutRef<typeof Item> {
	size?: VariantProp<typeof variants, "size">;
}

export const RadioButtonGroupItem = ({ className, size = "md", ...props }: RadioButtonGroupItemProps) => {
	const form = useFormContext();

	return <Item form={form?.id} {...props} className={variants({ size, className })} />;
};
